export const CHECKOUT_URL = 'https://conduca-infantil.impultienda.ar/checkout'

export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/gzxZB3uTqYENjb5Zj9NdQ2/mockup.png'

export const prices = {
  before: '$47.990',
  now: '$17.990',
  saving: '$30.000',
}

export const productPages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/kpTtvawvSvMU6y8PRY3WmY/Captura_de_pantalla_2026-10-01_a_la(s)_11.52.43_p._m..png',
    tag: 'Módulo 1',
    title: 'Descubro y construyo',
    desc: 'De las sílabas a sus primeras palabras y frases.',
    alt: 'Página del Módulo 1: Hola, soy Leo. Presenta las primeras 10 misiones de lectura: letras, sílabas, palabras y gran misión.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ovCW9n6fDjmq89FL6AFKps/Captura_de_pantalla_2026-10-01_a_la(s)_11.53.13_p._m..png',
    tag: 'Módulo 2',
    title: 'Leo y comprendo',
    desc: 'Frases, pequeñas lecturas y actividades de comprensión.',
    alt: 'Página de actividad Día 3: Completá la palabra. Seis dibujos con la sílaba faltante para elegir entre tres opciones.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nC21FRopzPeF1xsWBupvQh/Captura_de_pantalla_2026-10-01_a_la(s)_11.53.40_p._m..png',
    tag: 'Módulo 3',
    title: 'Gano fluidez',
    desc: 'Lecturas e historias para practicar comprensión, expresión y fluidez.',
    alt: 'Página de actividad Día 1: Leé y descubrí. Seis oraciones cortas para leer y marcar el dibujo correcto.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nfimBS62VYBRPXBwas4eLf/Captura_de_pantalla_2026-10-01_a_la(s)_11.54.01_p._m..png',
    tag: 'Bono 1',
    title: 'Juegos de lectura',
    desc: 'Bingo, memoria, dominó y actividades para practicar jugando.',
    alt: 'Página del Bono 1: Bingo de palabras con doce tarjetas ilustradas como sol, casa, gato y flor.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/udXFS78TAmes3AKrkd4GC3/Captura_de_pantalla_2026-10-01_a_la(s)_11.54.33_p._m..png',
    tag: 'Bono 2',
    title: 'Kit recortable de lectura',
    desc: 'Recortá, combiná y construí palabras y oraciones de una forma más visual.',
    alt: 'Página del Bono 2: El tren de las palabras. Vagones recortables con palabras para ordenar y armar cuatro frases.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kVcp7Un1Hj4i1fVZxGyMYT/Captura_de_pantalla_2026-10-01_a_la(s)_11.54.54_p._m..png',
    tag: 'Bono 3',
    title: 'Mini biblioteca infantil',
    desc: '4 historias cortas e ilustradas para llevar lo aprendido a la lectura.',
    alt: 'Página del Bono 3: El perrito perdido, una historia ilustrada en seis partes sobre ayudar y encontrar el camino a casa.',
  },
]

export const symptoms = [
  'Conoce las letras, pero todavía se traba al unirlas.',
  'Practicar puede terminar en aburrimiento o frustración.',
  'Puede leer algunas palabras, pero no siempre comprende lo que leyó.',
  'No sabés qué debería practicar primero y qué viene después.',
]

export const steps = ['Construye', 'Lee', 'Comprende', 'Practica fluidez', 'Celebra sus avances']

export const guides = [
  {
    title: 'DESCUBRO Y CONSTRUYO',
    subtitle: 'Primero construye la base.',
    desc: 'Durante los primeros 10 días trabaja sílabas, formación de palabras y primeras frases mediante actividades visuales y progresivas. El objetivo es que pueda pasar de reconocer elementos aislados a empezar a construir y leer.',
  },
  {
    title: 'LEO Y COMPRENDO',
    subtitle: 'Ahora leer empieza a tener sentido.',
    desc: 'Durante los días 11 al 20 empieza a trabajar frases, pequeñas lecturas, secuencias, preguntas, causas, consecuencias y comprensión. Porque leer no es solamente pronunciar palabras. También necesita entender qué está leyendo.',
  },
  {
    title: 'GANO FLUIDEZ',
    subtitle: 'Ahora une todo lo que aprendió.',
    desc: 'Durante los días 21 al 30 pasa progresivamente a lecturas e historias para seguir practicando continuidad, comprensión, expresión y fluidez. La dificultad aumenta paso a paso para acompañar su progreso.',
  },
]

// Add an `image` URL to any bonus to show a real page preview inside its block.
export const bonuses: { title: string; lead: string; desc: string; image?: string }[] = [
  {
    title: 'JUEGOS DE LECTURA',
    lead: 'Para esos días en los que necesita practicar de una manera diferente.',
    desc: 'Bingo, memoria, dominó y búsqueda de palabras para reforzar lo aprendido mientras juega.',
  },
  {
    title: 'KIT RECORTABLE DE LECTURA',
    lead: 'Para aprender tocando, moviendo y combinando.',
    desc: 'Tarjetas y actividades imprimibles para formar palabras, relacionar palabra + imagen y construir oraciones.',
  },
  {
    title: 'MINI BIBLIOTECA INFANTIL',
    lead: 'Para empezar a llevar lo aprendido a historias completas.',
    desc: '4 cuentos cortos e ilustrados para practicar lectura de una forma más entretenida.',
  },
  {
    title: 'MI PASAPORTE DE LECTURA',
    lead: 'Para que pueda ver todo lo que ya avanzó.',
    desc: 'Registro de lecturas, estrellas, camino lector y metas para acompañar sus logros durante el desafío.',
  },
  {
    title: 'KIT DE MOTIVACIÓN LECTORA',
    lead: 'Para reconocer su esfuerzo y celebrar cada paso.',
    desc: 'Medallas, insignias, tarjetas de felicitación y diploma final de Gran Lector.',
  },
]

export const faqs = [
  {
    q: '¿Para qué nivel está pensado?',
    a: 'Está pensado para chicos que están desarrollando sus primeras habilidades de lectura y necesitan avanzar progresivamente desde sílabas y palabras hacia frases, comprensión e historias.',
  },
  {
    q: '¿Tengo que empezar desde el día 1?',
    a: 'Lo ideal es seguir el recorrido progresivo, especialmente si todavía le cuesta construir palabras y frases.',
  },
  {
    q: '¿Qué pasa si ya reconoce letras y algunas palabras?',
    a: 'Puede utilizar las actividades correspondientes a su nivel y continuar avanzando progresivamente hacia comprensión y fluidez.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Después de realizar tu compra recibís acceso al material en formato digital.',
  },
  {
    q: '¿Es un producto físico?',
    a: 'No. Desafío Lector es 100% digital.',
  },
  {
    q: '¿El material es imprimible?',
    a: 'Sí. Podés imprimir las actividades que quieras utilizar desde casa.',
  },
  {
    q: '¿Tengo que imprimir todo?',
    a: 'No. Podés imprimir solamente las páginas que vayan necesitando.',
  },
  {
    q: '¿Puedo verlo desde el celular o tablet?',
    a: 'Sí. También podés visualizar los archivos desde celular, tablet o computadora.',
  },
  {
    q: '¿Sirve si se aburre cuando practica?',
    a: 'El Kit combina páginas visuales, actividades, juegos, recortables, cuentos y recompensas para ofrecer diferentes formas de practicar.',
  },
  {
    q: '¿Incluye cuentos?',
    a: 'Sí. La Mini Biblioteca Infantil incluye 4 historias cortas e ilustradas.',
  },
  {
    q: '¿Incluye recursos para motivarlo?',
    a: 'Sí. Incluye Pasaporte de Lectura, metas, estrellas, medallas, insignias, tarjetas y diploma.',
  },
  {
    q: '¿Tengo que pagar una mensualidad?',
    a: 'No. Es un único pago.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días de garantía.',
  },
]

export const costs = [
  ['Buscar ejercicios diferentes cada día', 'Perder tiempo sin saber qué hacer primero.'],
  ['Probar actividades sin un orden', 'No saber si realmente está avanzando.'],
  ['Darle ejercicios demasiado difíciles', 'Más frustración y menos ganas de practicar.'],
  ['Repetir siempre lo mismo', 'Aburrimiento y rechazo a la lectura.'],
  ['Practicar solamente palabras', 'Poder leer sin necesariamente comprender.'],
  ['No registrar sus avances', 'No visualizar todo lo que ya consiguió.'],
]
